// REACT
import React, { useRef } from "react";

// MATERIAL-UI
import { Grid, Popover, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// ASSESTS
import { FilterStyles } from "../styles/Filter.styles";
import { searchConstants as CONST } from "./constants";
import SearchListMarket from "./SearchListMarket";
import useTableSearch from "src/utils/hooks/useTableSearch";
import _ from "lodash";
import Preloader from "src/utils/Preloader";
import api from "src/store/features/api";
import { trackEvent } from "src/Amplitude";

const DEBOUNCE_TIME = 300;

const SearchBar = () => {
  const classes = FilterStyles();
  const [allCrypto] = api.useLazyGetCryptoCurrenciesQuery();
  const { data: trending } = api.useGetTrendingCryptoCurrenciesQuery({});
  const [open, setOpen] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);

  const isMounted = useRef(false);

  React.useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  // get / set search value
  const [searchVal, setSearchVal] = React.useState<string | null>(null);

  // filter data with search value
  const { filteredData } = useTableSearch({
    searchVal,
    retrieve: allCrypto,
  });

  // validate the users input
  const validateInput = (e: any) => {
    if (e.target.value === "") {
      setError(false);
      setSearchVal(null);
      return false;
    }

    if (e.target.value.match(/^[a-zA-Z0-9_ \b]+$/)) {
      setError(false);
      return true;
    } else {
      setError(true);
      console.warn("Only alphanumerical characters allowed");
      return false;
    }
  };

  // when user inputs, set search value and validate
  const handleSearchChange = _.debounce((e: React.ChangeEvent<HTMLInputElement>) => {
    if (validateInput(e)) {
      if (isMounted.current) {
        setSearchVal(e.target.value);
        setOpen(!!e.target.value);
        trackEvent(`Select_Search_Bar`, { token: e.target.value }, "Global_Search_Bar");
      }
      return;
    }
  }, DEBOUNCE_TIME);

  const inputRef = useRef<HTMLAnchorElement | null>();
  return (
    <Grid container className={classes.container}>
      {trending && (
        <Grid item xs style={{ width: "100%" }}>
          <TextField
            variant="outlined"
            autoFocus={true}
            placeholder={CONST.placeholder}
            className={classes.searchbar}
            onChange={handleSearchChange}
            onClick={() => setOpen(true)}
            inputRef={inputRef}
            error={!!error}
            type="text"
            InputProps={{
              startAdornment: <SearchIcon fontSize="medium" sx={{ color: "#3D4346" }} />,
            }}
          />
          <Popover
            open={open}
            onClose={() => setOpen(false)}
            anchorEl={inputRef.current}
            disableAutoFocus={true}
            elevation={0}
            anchorOrigin={{
              horizontal: -50,
              vertical: "bottom",
            }}>
            <Grid container className={classes.searchList}>
              <Grid item xs={12}>
                {/* ERROR */}
                {error && (
                  <div className={classes.error}>
                    <p>{CONST.errorMessage}</p>
                  </div>
                )}
                {/* LIST */}
                {!searchVal && trending ? (
                  <>
                    {trending.length <= 0 && <Preloader />}
                    <SearchListMarket data={trending} />
                  </>
                ) : (
                  <>
                    <SearchListMarket data={filteredData} />
                  </>
                )}
              </Grid>
            </Grid>
          </Popover>
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(SearchBar);
